module.exports = __webpack_public_path__ + "img/2c.7675deb0.svg";